module.exports = __webpack_public_path__ + "img/arrow.42621ca0.png";